<template>
  <a-card class="m-t-10" :bordered="false">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">会员详情</span>
  </a-card>
  <a-card :bordered="false">
    <div class="s_over_h mb25">
      <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333"><span>基础资料</span>
        <div>
          <a-button type="danger" class='m-r-10' v-has:userDetailAddBlack="pushBack">加入黑名单</a-button>
          <a-button type="primary" class='m-r-10' v-has:userDetailEditInfo='openEdit'>编辑资料</a-button>
        </div>
      </div>
      <div class="s_p24 s_flex_bian_c">
        <img class="s_bor100 width-150 height-150" :src="detail.headimgurl ? detail.headimgurl : require('@/assets/images/normal.png')" alt="" style="display:block;object-fit:cover">
        <div class="width80 s_flex_ali s_flex_wrap">
          <p class="width33 s_c333 m-b-15">昵称：{{detail.nickname || '-'}}</p>
          <p class="width33 s_c333 m-b-15">姓名：{{detail.real_name || '-'}}</p>
          <p class="width33 s_c333 m-b-15">总成长值：{{detail.grow_exp || '-'}} <span style="color:#05486a;marginLeft:20px;cursor:pointer" v-has:userAddGrowth="getGrowth">赠送成长值</span></p>
          <p class="width33 s_c333 m-b-15">微信号：{{detail.wechat_number || '-'}}</p>
          <p class="width33 s_c333 m-b-15">手机号：{{detail.phone || '-'}}</p>
          <p class="width33 s_c333 m-b-15">会员等级：{{detail.vip_level_name || '-'}}</p>
          <p class="width33 s_c333 m-b-15">会员ID：{{detail.member_id || '-'}}</p>
          <p class="width33 s_c333 m-b-15">生日：{{detail.birthday || '-'}}</p>
          <p class="width33 s_c333 m-b-15">性别：<span v-if='detail.sex == 0'>未知</span><span v-if='detail.sex == 1'>男</span><span v-if='detail.sex == 2'>女</span></p>
          <p class="width33 s_c333 ">所属门店：{{detail.store_info.store_name || '-'}}</p>
          <p class="width33 s_c333 " v-if='detail.province_id && detail.city_id && detail.district_id'>所在地区：{{detail.province_name}}{{detail.city_name}}{{detail.district_name}}</p>
          <p class="width33 s_c333 " v-else>所在地区：{{detail.address || '-'}}</p>
          <p class="width33 s_c333 ">注册时间：{{detail.register_time || '-'}}</p>
        </div>
      </div>
    </div>
    <div class="s_over_h mb25">
      <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333"><span>资产信息</span>
        <!-- <div> <a-button type="primary"  class='m-r-10'>发券</a-button><a-button type="primary"  class='m-r-10'>发微信红包</a-button></div> -->
        <div>
          <a-button type="primary" class='m-r-10' style="width:88px" v-has:membersAddPoint='()=>{showIntegral = true}'>给积分</a-button>
          <a-button type="primary" class='m-r-10' style="width:88px" v-has:userAddCoupon='()=>{showCoupon = true}'>派券</a-button>
        </div>
      </div>
      <div class="s_flex_ali s_flex_wrap s_ptb0lr24 p-t-24">
        <!-- <div class="width33 s_flex_ali">
          <p>零钱余额：0.00</p>
          <a-button type="link">获取明细</a-button>
        </div> -->
        <div class="width33 s_flex_ali">
          <p>可用积分：{{detail.point || 0}}</p>
          <!-- <a-button type="link" @click='showIntegral = true'>给积分</a-button> -->
          <a-button type="link" v-has:userPointLog='()=>{showList = true}'>获取明细</a-button>
        </div>
        <div class="width33 s_flex_ali">
          <p>微信红包：{{detail.bonus||0.00}}</p>
          <a-button type="link" v-has:userRedLog='()=>{showRedList = true}'>发放明细</a-button>
        </div>
        <div class="width33 s_flex_ali">
          <p>可用卡券：{{detail.conpon_count || 0}}</p>
          <!-- <a-button type="link" @click='showCoupon = true'>派券</a-button> -->
          <a-button type="link" v-has:userCouponLog='()=>{showCouponLog = true}'>获取明细</a-button>
        </div>
      </div>
    </div>
    <!-- 自定义信息 -->
    <div class=" s_over_h mb25">
      <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333">
        <p>自定义信息</p>
        <div>
          <a-button type="primary" class='m-r-10' v-has:userCustomerInfoCreate='()=>{createInfo()}'>添加</a-button>
        </div>
      </div>
      <div class="p-24 " v-if='attchList.length'>
        <div v-for='item in attchList' :key='item.id' class="s_flex_ali">
          <div><span>{{item.attach_field}}:</span><span>{{item.attach_info}}</span></div>
          <a-button type="link" v-has:userCustomerInfoEdit="()=>editInfo(item)">修改</a-button>
          <a-button type="link" v-has:userCustomerInfoDel="()=>delInfo(item)">删除</a-button>
        </div>
        <div v-if="attchTotal>5">
          <a-button @click="attchAllShow=true">查看更多</a-button>
        </div>
      </div>
      <div class="p-t-24" v-else>
        <a-empty description="暂无信息" />
      </div>
    </div>
    <div class=" s_over_h mb25">
      <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333">
        <p>标签信息</p>
        <div>
          <a-button type="primary" class='m-r-10' v-has:userDetailAddTag='()=>{showTags = true}'>添加标签</a-button>
          <a-button type="primary" class='m-r-10' v-has:userDetailEditRemark='()=>{showRemarks = true;remarks=detail.remark}'>编辑备注</a-button>
        </div>
      </div>
      <div class="p-24 s_flex_ali" v-if='user_taglist.length'>
        <div v-for='item in user_taglist' :key='item.id' class="s_po_re m-r-20 s_shou" v-has:userDetailTag='()=>delTag(item.tag_id)'>
          <p class="height-32 p-l-15 p-r-25 s_bor_cd9 s_flex_center ">{{item.tag_name}}</p>
          <CloseOutlined style="right: 5px;top: 9px;position: absolute;color:#999;" />
        </div>
      </div>
      <div class="p-t-24" v-else>
        <a-empty description="暂无标签" />
      </div>
      <!--  -->
      <div class=" s_over_h mb25">
        <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333">
          <p>扫码统计</p>
        </div>
        <div class="s_flex_ali p-24">
          <div class="flex_1">首次扫码时间：{{scanStatistics.first_time || '-'}}</div>
          <div class="flex_1">最近扫码时间：{{scanStatistics.last_time || '-'}}</div>
          <div class="flex_1"></div>
        </div>
        <div class="s_flex_ali p-24 p-t-5">
          <div class="flex_1">扫码个数：{{scanStatistics.scan_num || 0}}</div>
          <div class="flex_1">扫码次数：{{scanStatistics.scan_number || 0}}</div>
          <div class="flex_1">活动参与数：{{scanStatistics.act_num || 0}}</div>
        </div>
      </div>
      <div class=" s_over_h mb25">
        <div class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_bian_c  s_bf58 s_c333">
          <p>云店消费统计</p>
        </div>
        <div class="s_flex_ali p-24">
          <div class="flex_1">最近购买时间：{{consumption.last_time || '-'}}</div>
          <div class="flex_1"></div>
          <div class="flex_1"></div>
        </div>
        <div class="s_flex_ali  p-24 p-t-5">
          <div class="flex_1">累计消费次数：{{consumption.times || 0}}</div>
          <div class="flex_1">累计消费金额：￥{{consumption.amount || 0}}</div>
          <div class="flex_1">累计购买商品数：{{consumption.product || 0}}</div>
        </div>
      </div>
      <!--  -->
      <p class="s_fonts20  s_c333 m-b-25">备注</p>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='remark' :columns='columns' :data-source='remarkList'>
        <template #action>
          <a href="javascript:;" v-has:userDetailEditRemark="()=>{showRemarks = true;remarks = detail.remark}">编辑</a>
        </template>
      </a-table>
    </div>

  </a-card>
  <a-modal :keyboard="false" title="添加标签" centered v-model:visible="showTags" :width='800' :confirm-loading="confirmLoading" @ok="eidtTags" destroyOnClose>
    <a-checkbox-group class="width100" v-model:value="tagsList">
      <a-row>
        <a-col class="m-b-10" v-for='item in options' :key='item' :span="8">
          <a-checkbox :value="item.id">{{item.tag_name}}</a-checkbox>
        </a-col>
      </a-row>
    </a-checkbox-group>
  </a-modal>
  <a-modal :keyboard="false" title="添加备注" centered v-model:visible="showRemarks" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose @cancel='remarks="";remark_id=""'>
    <a-textarea v-model:value="remarks" placeholder="请输入备注内容" :rows="4" />
  </a-modal>
  <a-modal :keyboard="false" title="充值积分" centered v-model:visible="showIntegral" :confirm-loading="confirmLoading" @ok="eidtIntegral" destroyOnClose @cancel='integral="";integralRemarks=""'>
    <a-form-item name='' label='积分' help='可输入负数（负数为扣除积分）' :wrapper-col="{ span: 20, offset: 1 }">
      <a-input-number class="width100" v-model:value="integral" :precision='0' placeholder="请输入积分数" />
    </a-form-item>
    <a-form-item name='' label='备注' :wrapper-col="{ span: 20, offset: 1 }">
      <a-textarea v-model:value="integralRemarks" placeholder="如备注发放/扣除积分的原因，方便稽查" :rows="4" />
    </a-form-item>
  </a-modal>
  <a-modal :keyboard="false" title="编辑基础信息" centered v-model:visible="showEdit" :footer="null" destroyOnClose>
    <userEdit :formData='formData' v-on:onsubmit='onsubmit'></userEdit>
  </a-modal>
  <a-modal :keyboard="false" title="积分明细" centered v-model:visible="showList" :width='1200' :footer="null" destroyOnClose>
    <pointsList :id='$route.query.member_id'></pointsList>
  </a-modal>
  <a-modal :keyboard="false" title="卡券明细" centered v-model:visible="showCouponLog" :width='1200' :footer="null" destroyOnClose>
    <couponLog :id='$route.query.member_id'></couponLog>
  </a-modal>
  <a-modal :keyboard="false" title="派券" centered v-model:visible="showCoupon" :footer='null' destroyOnClose>
    <addCoupon v-on:onsubmit="onsubmitcoupon" :id='$route.query.member_id'></addCoupon>
  </a-modal>

  <!-- 成长值 -->
  <a-modal :keyboard="false" title="赠送成长值" centered v-model:visible="showGrowth" destroyOnClose @Cancel="()=>{detail.exp=''}" @Ok="postAddExp">
    <a-form-item name='' label='当前成长值：' :labelCol="{span:6}">
      <div>{{detail.userExp}}</div>
    </a-form-item>
    <a-form-item name='' label='赠送成长值 ' :labelCol="{span:6}" :wrapper-col="{ span: 14 }" :help="`最多能赠送 ${detail.needExp} 成长值，保存后将根据新的总成长值更新会员等级信息`">
      <a-input-number class="width100" v-model:value="detail.exp" placeholder="请输入成长值" v-inputFilter:maxExp="{max:detail.needExp}" />
    </a-form-item>
  </a-modal>
  <!-- 红包明细 -->
  <a-modal :keyboard="false" title="红包明细" centered v-model:visible="showRedList" :width='1200' :footer="null" destroyOnClose>
    <redLog :id='$route.query.member_id'></redLog>
  </a-modal>

  <!-- 自定义信息-->
  <a-modal :keyboard="false" title="自定义信息" centered v-model:visible="visible" @ok="handleOk" destroyOnClose>
    <a-form :labelCol="{span:7}">
      <a-form-item label="自定义信息字段">
        <selectCustomerWord v-model:value="infoData.attach_field_id" :attach_field_id="infoData.attach_field_id" />
      </a-form-item>
      <a-form-item label="字段内容">
        <a-input v-model:value="infoData.attach_info" style="width:230px"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 会员的自定义信息-->
  <a-modal :keyboard="false" title="自定义信息" centered v-model:visible="attchAllShow" @ok="handleOk" destroyOnClose :width="1000">
    <attachInfo :user_id="$route.query.member_id" />
  </a-modal>
</template>
<script>
import {
  ExclamationCircleOutlined,
  CloseOutlined,
  LeftOutlined,
} from "@ant-design/icons-vue";
import { onMounted, inject, reactive, toRefs, h, createVNode, ref } from "vue";
import { message, Modal } from "ant-design-vue";
import {
  getMemberDetail,
  addUserBack,
  getMemberTagList,
  addUserPoint,
  tagMember,
  tagMemberDel,
  editUserRemark,
  getMemberNeedExp,
  postMemberAddExp,
  consumptionStatistics,
  getScanStatistics,
  member_attach_info,
  updateMemberAttachInfo,
  createMemberAttachInfo,
  delMemberAttachInfo
} from "@/api/member";
import { iscode } from "@/utils/app";
import userEdit from "./components/index.vue";
import pointsList from "./components/list.vue";
import couponLog from "./components/couponLog.vue";
import addCoupon from "./components/addCoupon.vue";
import redLog from "./components/redLog.vue";
import attachInfo from './components/attachInfo.vue'
export default {
  components: {
    userEdit,
    pointsList,
    CloseOutlined,
    LeftOutlined,
    addCoupon,
    couponLog,
    redLog,
    attachInfo
  },
  setup() {
    const state = reactive({
      showCouponLog: false,
      showCoupon: false,
      listLoading: false,
      confirmLoading: false,
      data: [],
      detail: {
        store_info: {},
      },
      showRemarks: false,
      remarks: "",
      remark_id: "",
      showIntegral: false,
      integral: "",
      integralRemarks: "",
      showTags: false,
      tagsList: [],
      options: [],
      showEdit: false,
      showList: false,
      user_taglist: [],
      formData: {},
      remarkList: [],
      showGrowth: false,
      consumption: {},
      scanStatistics: {},
      showRedList: false,
    });
    let columns = [
      {
        title: "内容",
        dataIndex: "remark",
        key: "remark",
        customRender: ({ record }) => {
          return record.remark ? record.remark : "-";
        },
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    //备注
    const eidtRemarks = async () => {
      state.confirmLoading = true;
      let res = await editUserRemark({
        remark: state.remarks,
        member_id: $route.query.member_id,
      })
        .then((res) => res.data)
        .catch((error) => error);

      if (iscode(res)) {
        state.showRemarks = false;
        message.success(res.msg);
        initData();
        state.remarks = "";
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false;
    };
    //积分
    const eidtIntegral = async () => {
      if (!state.integral) {
        message.error("请输入积分！");
        return;
      }
      state.confirmLoading = true;
      let res = await addUserPoint({
        remark: state.integralRemarks,
        member_id: $route.query.member_id,
        point: state.integral,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.showIntegral = false;
        message.success(res.msg);
        initData();
        state.integral = "";
        state.integralRemarks = "";
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false;
    };
    //加标签
    const eidtTags = async () => {
      state.confirmLoading = true;
      let res = await tagMember({
        user_id: $route.query.member_id,
        tag_id: state.tagsList,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        message.success(res.msg);
        state.showTags = false;
        initData();
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false;
    };
    //删标签
    const delTag = async (e) => {
      let res = await tagMemberDel({
        member_id: $route.query.member_id,
        tag_id: e,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        message.success(res.msg);
        initData();
      } else {
        message.error(res.msg);
      }
    };
    //打开编辑
    const openEdit = () => {
      state.formData = {
        id: $route.query.member_id,
        real_name: state.detail.real_name || "",
        province_id: state.detail.province_id || "",
        city_id: state.detail.city_id || "",
        district_id: state.detail.district_id || "",
        mobile: state.detail.phone || "",
        wechat_number: state.detail.wechat_number || "",
        birthday: state.detail.birthday || "",
      };
      state.showEdit = true;
    };
    //编辑完毕
    const onsubmit = () => {
      state.showEdit = false;
      initData();
    };
    //派券
    const onsubmitcoupon = () => {
      state.showCoupon = false;
      initData();
    };
    //获取标签
    const getTagsList = async () => {
      let res = await getMemberTagList({ limit: 99 }).then((res) => res.data);
      if (iscode(res)) {
        state.options = res.data.data;
      }
    };
    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await getMemberDetail($route.query.member_id)
        .then((res) => res.data)
        .catch((error) => error);
      state.detail = result.data;
      state.remarkList = [{ remark: state.detail.remark }];
      state.user_taglist = result.data.member_tag || [];
      state.tagsList = _lodash.map(result.data.member_tag, "tag_id");
      state.listLoading = false;
      setTimeout(hide);
    };
    // 加入黑名单
    const pushBack = () => {
      Modal.confirm({
        centered: true,
        width: 500,
        title: "加入黑名单",
        icon: createVNode(ExclamationCircleOutlined),
        content: h("div", {}, [
          h(
            "p",
            { className: "m-b-15" },
            "确定把" + state.detail.nickname + "加入黑名单吗？"
          ),
          h(
            "p",
            "加入平台黑名单后，该用户将无法参与所有活动及商品购买行为，请慎用该操作！"
          ),
          h("p", "如需撤销黑名单，请到“黑名单管理”进行撤销操作。"),
        ]),
        onOk: async () => {
          let res = await addUserBack($route.query.member_id).then(
            (res) => res.data
          );
          iscode(res, true);
        },
      });
    };

    //获取成长值
    const getGrowth = async function (data) {
      let res = await getMemberNeedExp({ uid: state.detail.member_id }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.detail.needExp = res.data.needExp;
        state.detail.userExp = res.data.userExp;
        state.detail.exp = "";
        state.showGrowth = true;
      } else {
        message.error(res.msg);
      }
    };

    //添加成长值
    const postAddExp = async function () {
      const hide = message.loading("正在加载中...", 0);
      let res = await postMemberAddExp({
        exp: state.detail.exp,
        uid: state.detail.member_id,
      }).then((res) => res.data);
      setTimeout(hide);
      if (iscode(res)) {
        message.success(res.msg);
        state.showGrowth = false;
        initData();
      } else {
        message.error(res.msg);
      }
    };

    //云店消费
    const getConsumptionStatistics = async function () {
      // state.detail.member_id
      let res = await consumptionStatistics({
        member_id: state.detail.member_id,
      }).then((res) => res.data);
      if (iscode(res)) {
        state.consumption = res.data || {};
      } else {
        message.error(res.msg);
      }
    };
    //扫码统计
    const getScanList = async function () {
      let res = await getScanStatistics({
        member_id: state.detail.member_id,
      }).then((res) => res.data);
      if (iscode(res)) {
        state.scanStatistics = res.data || {};
      } else {
        message.error(res.msg);
      }
    };
      // 列表
      const attchList=ref([])
      const attchTotal=ref(0)
      const getList=async ()=>{
        let result=await member_attach_info({user_id:$route.query.member_id,limit:5}).then(res=>res.data).catch(error=>error)
        attchList.value=result.data.data
        attchTotal.value=result.data.total
      }
    onMounted(async () => {
      await initData();
      getTagsList();
      getConsumptionStatistics();
      getScanList();
    getList()
    });

    var infoHandleHooks = () => {
      const attchAllShow=ref(false)
      const visible = ref(false);
      const infoData = ref({ attach_info: "" });
      // 添加
      const createInfo = (data) => {
        infoData.value = { attach_info: "" };
        visible.value = true;
      };
      // 修改
      const editInfo = (data) => {
        infoData.value = JSON.parse(JSON.stringify(data));
        visible.value = true;
      };
      // 删除
      const delInfo = (data) => {
        Modal.confirm({
          centered: true,
          content: "删除后将无法恢复，您确定要删除吗？",
          onOk: async () => {
            let res = await delMemberAttachInfo(data.id).then((res) => res.data);
            if (iscode(res, true)) {
               getList();
            }
          },
        });
      };
      // 确认
      const handleOk = async () => {
        let result;
        if (infoData.value.id) {
           result =await updateMemberAttachInfo(infoData.value.id,{...infoData.value,user_id:$route.query.member_id}).then(res=>res.data).catch(error=>error)
        } else {
          console.log("添加");
           result =await createMemberAttachInfo({...infoData.value,user_id:$route.query.member_id,}).then(res=>res.data).catch(error=>error)
        }
        if (iscode(result, true)) {
          visible.value = false;
          getList();
        }
      };
      return {
        createInfo,
        visible,
        infoData,
        editInfo,
        handleOk,
        delInfo,
        getList,
        attchAllShow
      };
    };
    return {
      ...toRefs(state),
      pushBack,
      columns,
      eidtRemarks,
      eidtIntegral,
      eidtTags,
      delTag,
      openEdit,
      onsubmit,
      onsubmitcoupon,
      getGrowth,
      postAddExp,
      getScanList,
      ...infoHandleHooks(),
      attchList,
      attchTotal
    };
  },
};
</script>
